export default {
	data() {
		return {
			manifests: [],
			selectedManifestIds: [],
			metadatas: [],
			metadataValues: [],
			metadataFilter: {
				label: '',
				value: ''
			},
			searchQuery: '',
			isFetching: false,
			isFetched: false,
			isSearching: false,
			isSearched: false,
			isSorting: false,
			isChangingPage: false,
			success: false,
			error: false,
			isSelectedAll: false,
			isIndeterminate: false,
		}
	},
	mounted() {
		this.fetchManifestMetadatas();
		this.fetchManifests();
		
		// Init field
		if(typeof this.$route.query.keyword !== 'undefined') {
			this.searchQuery = this.$route.query.keyword;
			this.isSearching = true;
		}
		
		if(typeof this.$route.query.filterBy !== 'undefined' && typeof this.$route.query.filter !== 'undefined') {
			this.isSearching = true;
		}
	},
	watch: {
		'manifests.data': {
			handler: function (values) {
				const selected = values.filter(manifest => manifest.selected);
				this.isIndeterminate = selected.length >= 1 && selected.length < values.length;
				this.isSelectedAll = selected.length === values.length;
            },
            deep: true
		},
		$route(to, from) {
			this.manifests.data = [];
			this.fetchManifests();
		},
		'metadataFilter.label': function(newVal, oldVal) {
			if(newVal === 'no-filter') {
				this.metadataFilter.value = '';
				this.metadataFilter.label = '';
				this.metadataValues = [];
				this.filterManifests();
			} else {
				var metadata = this.metadatas.find(metadata => {
					return metadata.label == newVal;
				});
				
				this.metadataValues = typeof metadata !== 'undefined' ? metadata.values : [];
				this.metadataFilter.value = this.$route.query.filter;
			}
		},
	},
	methods: {
		fetchManifestMetadatas() {
			axios.get('/fetchManifestMetadatas').then(response => {
				this.metadatas = response.data;
				this.metadataFilter.label = this.$route.query.filterBy;
			});
		},
		ariaSort(fieldName) {
			if(this.$route.query.sortBy === fieldName) {
				return this.$route.query.sort === 'ASC' ? 'ascending' : 'descending';
			} else {
				return 'none';
			}
		},
		sortManifests(fieldName) {
			var sortBy = fieldName;
			var sort = null;
			
			if(this.$route.query.sortBy === sortBy) {
				if(this.$route.query.sort === 'ASC') {
					sort = 'DESC';
				} else {
					sortBy = 'id';
					sort = 'ASC';
				}
			} else {
				sort = 'ASC';
			}
			
			this.isSorting = true;
			this.$router.push({name: this.$route.name, query: {page: this.$route.query.page, sortBy: sortBy, sort: sort, filterBy: this.$route.query.filterBy, filter: this.$route.query.filter, keyword: this.$route.query.keyword}});
		},
		searchManifests() {
			this.isSearching = true;
			this.$router.push({name: this.$route.name, query: {page: 1, sortBy: this.$route.query.sortBy, sort: this.$route.query.sort, filterBy: this.$route.query.filterBy, filter: this.$route.query.filter, keyword: this.searchQuery}});
    	},
    	filterManifests() {
    		this.isSearching = true;
    		this.$router.push({name: this.$route.name, query: {page: 1, sortBy: this.$route.query.sortBy, sort: this.$route.query.sort, filterBy: this.metadataFilter.label, filter: this.metadataFilter.value, keyword: this.$route.query.keyword}});
    	},
    	goToPage(page) {
    		this.isChangingPage = true;
    		this.$router.push({name: this.$route.name, query: {page: page, sortBy: this.$route.query.sortBy, sort: this.$route.query.sort, filterBy: this.$route.query.filterBy, filter: this.$route.query.filter, keyword: this.$route.query.keyword}});
		},
		toggleAll() {
			this.manifests.data.forEach(manifest => {
				Vue.set(manifest, 'selected', this.isSelectedAll)
			});
			
			const nonSelected = this.manifests.data.filter(manifest => !manifest.selected)
			const selected = this.manifests.data.filter(manifest => manifest.selected)
			
			// new selected manifest IDs array without manifest IDs of the current page.
			let selectedManifestIdsCopy = this.selectedManifestIds.slice().filter(manifestId =>
				!nonSelected.find(e => e.id === manifestId)
			)
			
			let selectedManifests = selected.filter(manifest => !selectedManifestIdsCopy.find(e => e === manifest.id))
			let selectedManifestIds = _.map(selectedManifests, 'id')
			
			this.selectedManifestIds = [
				...selectedManifestIdsCopy,
				...selectedManifestIds
			];
		},
		toggleManifest(manifest) {
			if(manifest.selected) {
				this.selectedManifestIds.push(manifest.id);
			}
			else {
			    const index = this.selectedManifestIds.indexOf(manifest.id);
			    this.selectedManifestIds.splice(index, 1);
			}
		},
		clearSelection() {
			this.selectedManifestIds = [];
			this.manifests.data.forEach(manifest => {
				Vue.set(manifest, 'selected', false)
			});
		},
		resetFlags() {
			this.isChangingPage = false;
			this.isSorting = false;
			this.isSearching = false;
		}
	}
};